
/*
*###############################################################################
*Module Name                   : TextValidation.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 15th 2021, 3:02:19 pm          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import { isNumber } from "lodash";


const TextValidation = (Type, elm, maxLen, para1, para2, para3, para4) => {

    if (Type == "numeric") {
        return Numeric(elm, maxLen, para1, para2);
    }
    if (Type == "text") {
        return Text(elm, maxLen, para1, para2, para3, para4)
    }
}

/*
desc:
params:
return string
*/
const Numeric = (elm, maxLen, deciPl, alMinus, astric = false) => {
    //debugger;  
    //string is null, nothing to validate
    if (elm == null) { return '0'; }

    let str = elm.value;
    let intCutPos = elm.selectionStart;

    //max length
    if (maxLen != null && str.length > maxLen) {
        str = str.slice(0, maxLen);
    }

    let regexPat = /^[\d]+$/;
    //decimal places and allow minus
    if (
        deciPl != null && deciPl > 0 &&
        alMinus != null && alMinus == true
    ) {
        regexPat = new RegExp('^(-|)[\d]+(\.[\d]{1, ' + deciPl + '}|)$');
    }//decimal places
    else if (deciPl != null && deciPl > 0) {
        regexPat = new RegExp('^[\d]+(\.[\d]{1, ' + deciPl + '}|)$');
    }//allow minus
    else if (alMinus != null && alMinus == true) {
        regexPat = /^(-|)[\d]+$/;
    }

    if (str != '-' && str != '.' && str.match(regexPat)) {
        /*
        //match decimal places
        if( deciPl != null && deciPl > 0 ){
            let fltNumber = parseFloat(str);
            if(isNaN(fltNumber)){ fltNumber = 0; }
            str = fltNumber.toFixed(deciPl);
        }
        */
        elm.value = str;
        elm.selectionStart = intCutPos;
        elm.selectionEnd = intCutPos;
        return str;
    }

    //Sanitize
    let regexSanitizePat = /(?![\.\-])[\D]+/;
    if (astric == true) {
        regexSanitizePat = /(?![\.\-\*])[\D]+/;
    }

    //non numeric
    str = str.replace(regexSanitizePat, '');

    //remove decimal symbol
    if (deciPl == null || deciPl == 0) {
        regexSanitizePat = /[\.]+/;
        str = str.replace(regexSanitizePat, '');
    }

    //remove minus symbol
    if (alMinus == null || alMinus == false) {
        regexSanitizePat = /[\-]+/;
        str = str.replace(regexSanitizePat, '');
    } else {
        regexSanitizePat = /(?!^.+)[\-]+/;
        str = str.replace(regexSanitizePat, '',);
    }

    /*
    //match decimal places
    if( str != '-' && str != '.' && str.length > 0 && deciPl != null && deciPl > 0 ){
        let fltNumber = parseFloat(str);
        if(isNaN(fltNumber)){ fltNumber = 0; }
        str = fltNumber.toFixed(deciPl);
    }
    */

    //remove multiple decimal symbols
    if (str.length > 0 && str != '-' && str != '.' && deciPl != null && deciPl > 0) {
   
        let parts = str.split('.');
  
        if (str.indexOf('.') > 0) {
            str = '';
            for (let i = 0; i <= parts.length; i++) {
                str += (i == 1 ? '.' + (parts[i] == undefined ? '' : parts[i]) : (parts[i] == undefined ? '' : parts[i]));
            }
            str = str.slice(0, (str.indexOf('.') + deciPl + 1));
        }
    }
    elm.value = str;
    elm.selectionStart = intCutPos;
    elm.selectionEnd = intCutPos;
    return str;
}


/**
 * Validates and formats numeric input in a text field.
 *
 * @param {HTMLInputElement} inputElement - The input element to validate.
 * @param {number} maxLength - The maximum length of the input.
 * @param {number} decimalPlaces - The number of decimal places to allow.
 * @param {boolean} allowMinus - Whether to allow a minus sign.
 * @param {boolean} allowAsterisk - Whether to allow an asterisk character.
 * @returns {string} The validated and formatted numeric value.
 */
// const Numeric = (inputElement, maxLength, decimalPlaces, allowMinus, allowAsterisk = false) => {
//     // Validate input element

//     let inputValue = inputElement.value;
//     const selectionStart = inputElement.selectionStart;

//     // Trim the input if it exceeds the maximum length
//     if (maxLength != null && inputValue.length > maxLength) {
//         inputValue = inputValue.slice(0, maxLength);
//         inputElement.value = inputValue;
//         inputElement.selectionStart = selectionStart;
//         inputElement.selectionEnd = selectionStart;
//         return inputValue;
//     }

//     // Define regex pattern based on options
//     let regexPattern;
//     if (decimalPlaces != null && decimalPlaces > 0 && allowMinus) {
//         regexPattern = new RegExp('^-?\\d+(\\.\\d{1,' + decimalPlaces + '})?$');
//     } else if (decimalPlaces != null && decimalPlaces > 0) {
//         regexPattern = new RegExp('^\\d+(\\.\\d{1,' + decimalPlaces + '})?$');
//     } else if (allowMinus) {
//         regexPattern = /^-?\d+/;
//     } else {
//         regexPattern = /^\d+/;
//     }

//     // Check if the input matches the regex pattern
//     if (inputValue !== '-' && inputValue !== '.' && inputValue.match(regexPattern)) {
//         // Input is valid, no changes needed
//         inputElement.value = inputValue;
//         inputElement.selectionStart = selectionStart;
//         inputElement.selectionEnd = selectionStart;
//         return inputValue;
//     }

//     // Sanitize input based on options
//     const sanitizePattern = allowAsterisk ? /[^\d.*-]+/g : /[^\d.-]+/g;
//     inputValue = inputValue.replace(sanitizePattern, '');

//     // Remove decimal symbol if decimalPlaces is 0
//     if (decimalPlaces === 0) {
//         inputValue = inputValue.replace(/[.]+/g, '');
//     }

//     // Remove minus symbol if not allowed
//     if (!allowMinus) {
//         inputValue = inputValue.replace(/[-]+/g, '');
//     } else {
//         inputValue = inputValue.replace(/(?!.+)[-]+/g, '');
//     }

//     // Format the input if decimalPlaces are specified
//     if (inputValue !== '-' && inputValue !== '.' && inputValue.length > 0 && decimalPlaces != null && decimalPlaces > 0) {
//         const parts = inputValue.split('.');
//         if (inputValue.indexOf('.') > 0) {
//             inputValue = '';
//             for (let i = 0; i < parts.length; i++) {
//                 inputValue += (i === 1 ? `.${parts[i] || ''}` : parts[i] || '');
//             }
//             inputValue = inputValue.slice(0, inputValue.indexOf('.') + decimalPlaces + 1);
//         }
//     }
//     inputElement.value = inputValue;
//     inputElement.selectionStart = selectionStart;
//     inputElement.selectionEnd = selectionStart;
//     return inputValue;
// };


// const Numeric = (elm, maxLen, deciPl, alMinus, astric = false) => {
//     //debugger;
//     //string is null, nothing to validate
//     if (elm == null) { return '0'; }

//     let str = elm.value;
//     let intCutPos = elm.selectionStart;

//     //max length
//     if (maxLen != null && str.length > maxLen) {
//         str = str.slice(0, maxLen);
//     }

//     let regexPat = /^[\d]+$/;
//     //decimal places and allow minus
//     if (
//         deciPl != null && deciPl > 0 &&
//         alMinus != null && alMinus == true
//     ) {
//         regexPat = new RegExp('^-?\\d+(\\.\\d{1,' + deciPl + '})?$');
//     }//decimal places
//     else if (deciPl != null && deciPl > 0) {
//         regexPat = new RegExp('^\\d+(\\.\\d{1,' + deciPl + '})?$');
//     }//allow minus
//     else if (alMinus != null && alMinus == true) {
//         regexPat = /^-?\d+$/;
//     }

//     if (str != '-' && str != '.' && str.match(regexPat)) {
//         /*
//         //match decimal places
//         if( deciPl != null && deciPl > 0 ){
//             let fltNumber = parseFloat(str);
//             if(isNaN(fltNumber)){ fltNumber = 0; }
//             str = fltNumber.toFixed(deciPl);
//         }
//         */
//         elm.value = str;
//         elm.selectionStart = intCutPos;
//         elm.selectionEnd = intCutPos;
//         return str;
//     }

//     //Sanitize
//     let regexSanitizePat = /[^\d.-]+/;
//     if (astric == true) {
//         regexSanitizePat = /[^\d.*-]+/;
//     }

//     //non numeric
//     str = str.replace(regexSanitizePat, '');

//     //remove decimal symbol
//     if (deciPl == null || deciPl == 0) {
//         regexSanitizePat = /[.]+/;
//         str = str.replace(regexSanitizePat, '');
//     }

//     //remove minus symbol
//     if (alMinus == null || alMinus == false) {
//         regexSanitizePat = /[-]+/;
//         str = str.replace(regexSanitizePat, '');
//     } else {
//         regexSanitizePat = /(?!.+)[-]+/;
//         str = str.replace(regexSanitizePat, '');
//     }

//     /*
//    //match decimal places
//    if( str != '-' && str != '.' && str.length > 0 && deciPl != null && deciPl > 0 ){
//        let fltNumber = parseFloat(str);
//        if(isNaN(fltNumber)){ fltNumber = 0; }
//        str = fltNumber.toFixed(deciPl);
//    }
//    */

//     //remove multiple decimal symbols
//     if (str.length > 0 && str != '-' && str != '.' && deciPl != null && deciPl > 0) {
//         console.log(str);
//         let parts = str.split('.');
//         console.log(parts);
//         if (str.indexOf('.') > 0) {
//             str = '';
//             for (let i = 0; i <= parts.length; i++) {
//                 str += (i == 1 ? '.' + (parts[i] == undefined ? '' : parts[i]) : (parts[i] == undefined ? '' : parts[i]));
//             }
//             str = str.slice(0, (str.indexOf('.') + deciPl + 1));
//         }
//     }
//     elm.value = str;
//     elm.selectionStart = intCutPos;
//     elm.selectionEnd = intCutPos;
//     return str;
// }



/*
desc:
params:
return string
 */

const Text = (elm, maxLen, alNumeric, alSpecialChar, caseType, alSpaces) => {
    //;
    //string is null, nothing to validate
    if (elm == null) { return '0'; }

    let str = elm.value;
    let intCutPos = elm.selectionStart;

    //max length
    if (maxLen != null && str.length > maxLen) {
        str = str.slice(0, maxLen);
    }

    let regexPat = /\w*/;
    if (alNumeric != null && alNumeric == true && alSpaces != null && alSpaces == true && alSpecialChar != null && alSpecialChar == true) {
        regexPat = /\w*\s*\.*\,*\-*\_*\d*/;
    } else if (alNumeric != null && alNumeric == true && alSpaces != null && alSpaces == true) {
        regexPat = /\w*\s*\d*/;
    } else if (alNumeric != null && alNumeric == true && alSpecialChar != null && alSpecialChar == true) {
        regexPat = /\w*\.*\,*\-*\_*\d*/;
    } else if (alSpaces != null && alSpaces == true && alSpecialChar != null && alSpecialChar == true) {
        regexPat = /\w*\*\s*\.*\,*\-*\_*/;
    } else if (alNumeric != null && alNumeric == true) {
        regexPat = /(^\S+$)/;
    }


    /*if(str.match(regexPat)){ 
       if(caseType == "upper"){
        str = UpperCase(str);
       }else if(caseType == "lower"){
        str = LowerCase(str);
       }else if(caseType == "camel"){
            str = CamelCase(str)
       }
        elm.value = str;
        elm.selectionStart = intCutPos;
        elm.selectionEnd = intCutPos;
        //return str;
    }*/

    //Sanitize
    let regexSanitizePat = /(?![\.\-])+/;
    //numeric validation
    if (alNumeric != null && alNumeric == false) {
        regexSanitizePat = /\d/;
        str = str.replace(regexSanitizePat, '',);
    }

    if (alSpaces != null && alSpaces == false) {
        regexSanitizePat = /\s/;
        str = str.replace(regexSanitizePat, '',);
    }

    if (alSpecialChar != null && alSpecialChar == false) {
        // regexSanitizePat = /[$~`&+,:;=?@#|'"/<>.{}^*()[\]\\%!-]/;
        regexSanitizePat = /[$~`&+,:;=?@#|'"/<>.{}^*()[\]\\%!-]/;
        str = str.replace(regexSanitizePat, '',);
    } else if (alSpecialChar != null && alSpecialChar == true) {
        regexSanitizePat = /['"]+/;
        str = str.replace(regexSanitizePat, '',);
    }

    if (caseType == "upper") {
        str = UpperCase(str);
    } else if (caseType == "lower") {
        str = LowerCase(str);
    } else if (caseType == "camel") {
        str = CamelCase(str)
    }
    elm.value = str;
    elm.selectionStart = intCutPos;
    elm.selectionEnd = intCutPos;
    return str;
}

function CamelCase(str) {
    return str
        .replace(/^[a-zA-Z]/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s/g, ' ')
    /*.replace(/^(.)/, function($1) { return $1.toLowerCase(); });*/
}

function UpperCase(str) {
    return str
        .replace(/[a-zA-Z]/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s/g, ' ')
    /*.replace(/^(.)/, function($1) { return $1.toLowerCase(); });*/
}

function LowerCase(str) {
    return str
        .replace(/[a-zA-Z]/g, function ($1) { return $1.toLowerCase(); })
        .replace(/\s(.)/g, function ($1) { return $1.toLowerCase(); })
        .replace(/\s/g, ' ')
    /*.replace(/^(.)/, function($1) { return $1.toLowerCase(); });*/
}

const CodeValidation = (str) => {
    if (str.length > 6) {
        return false
    } else {
        if (str.length <= 0) {
            return true
        } else {
            str = str.slice(-1)
            if (str.match(/([a-zaA-Z0-9-_])/g)) {
                return true
            } else {
                return false
            }
        }
    }
}

const ProCodeValidation = (str) => {
    if (str.length > 12) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([a-zaA-Z0-9-_])/g)) {
            return true
        } else {
            return false
        }
    }
}

const ProDescValidation = (str) => {
    if (str.length > 60) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([a-zaA-Z0-9!@#$()+,/-])/g)) {
            return true
        } else {
            return false
        }
    }
}

const NameValidation = (str) => {
    if (str.length > 50) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([a-zaA-Z0-9])/g)) {
            return true
        } else {
            return false
        }
    }
}

const EmailValidation = (str) => {
    if (str.length > 40) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([a-zaA-Z0-9@_.])/g)) {
            return true
        } else {
            return false
        }
    }
}

const TelephoneValidation = (str) => {
    if (str.length > 15) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([0-9])/g)) {
            return true
        } else {
            return false
        }
    }
}

const AmountValidation = (str) => {
    if (str.length > 14) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([0-9.+-,])/g)) {
            return true
        } else {
            return false
        }
    }
}

const QtyValidation = (str) => {
    if (str.length > 9) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([0-9.])/g)) {
            return true
        } else {
            return false
        }
    }
}

const DiscountPerValidation = (str) => {
    if (str.length > 6) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([0-9.+-])/g)) {
            return true
        } else {
            return false
        }
    }
}

const DiscountAmtValidation = (str) => {
    if (str.length > 14) {
        return false
    } else {
        str = str.slice(-1)
        if (str.match(/([0-9.,+-])/g)) {
            return true
        } else {
            return false
        }
    }
}

function toCamelCase(str) {
    return str
        .replace(/^[a-zA-Z]/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s/g, ' ')
    /*.replace(/^(.)/, function($1) { return $1.toLowerCase(); });*/
}


// function DecimalValidation(value, defaultValue = 0, isDecimal = false, defaultDecimals = 2) {
//     value = String(value); 

//     if (/^\.{1,}$/.test(value) || value === "" || /\.{2,}/.test(value) || /[^\d.]+|\d+\.\d+\./.test(value)) {
//         return defaultValue.toFixed(isDecimal ? 2 : 0);
//     } else {
//         var decimalValue = isDecimal ? defaultDecimals : (value.includes('.') ? value.split('.')[1].length : 0);
//         return parseFloat(value).toFixed(decimalValue);
//     }
// }

function DecimalValidation(value, defaultValue = 0, isDecimal = false, defaultDecimals = 2) {
    value = String(value);

    if (value === "") {
        return defaultValue.toFixed(isDecimal ? defaultDecimals : 0);
    }

    // Check if it's a negative number
    if (/^-?\d*\.?\d*$/.test(value)) {
        var decimalValue = isDecimal ? defaultDecimals : (value.includes('.') ? value.split('.')[1].length : 0);
        return parseFloat(value).toFixed(decimalValue);
    }

    // Other validation conditions
    if (value === "" || /\.{2,}/.test(value) || /[^\d.-]+|\d+\.\d+\./.test(value)) {
        return defaultValue.toFixed(isDecimal ? 2 : 0);
    } else {
        var decimalValue = isDecimal ? defaultDecimals : (value.includes('.') ? value.split('.')[1].length : 0);
        return parseFloat(value).toFixed(decimalValue);
    }
}







export { TextValidation, Numeric, Text, DecimalValidation };